var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 216 154.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{stroke:url(#New_Gradient_Swatch_2-79);stroke-width:.86px;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97{fill:none;stroke-miterlimit:10;}.cls-3{stroke:url(#New_Gradient_Swatch_2-33);}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93{stroke-width:1.4px;}.cls-4{stroke:url(#New_Gradient_Swatch_2-10);}.cls-5{stroke:url(#New_Gradient_Swatch_2-11);}.cls-6{stroke:url(#New_Gradient_Swatch_2-13);}.cls-7{stroke:url(#New_Gradient_Swatch_2-12);}.cls-8{stroke:url(#New_Gradient_Swatch_2-19);}.cls-9{stroke:url(#New_Gradient_Swatch_2-18);}.cls-10{stroke:url(#New_Gradient_Swatch_2-15);}.cls-11{stroke:url(#New_Gradient_Swatch_2-17);}.cls-12{stroke:url(#New_Gradient_Swatch_2-14);}.cls-13{stroke:url(#New_Gradient_Swatch_2-45);}.cls-14{stroke:url(#New_Gradient_Swatch_2-42);}.cls-15{stroke:url(#New_Gradient_Swatch_2-43);}.cls-16{stroke:url(#New_Gradient_Swatch_2-30);}.cls-17{stroke:url(#New_Gradient_Swatch_2-32);}.cls-18{stroke:url(#New_Gradient_Swatch_2-31);}.cls-19{stroke:url(#New_Gradient_Swatch_2-34);}.cls-20{stroke:url(#New_Gradient_Swatch_2-35);}.cls-21{stroke:url(#New_Gradient_Swatch_2-58);}.cls-22{stroke:url(#New_Gradient_Swatch_2-59);}.cls-23{stroke:url(#New_Gradient_Swatch_2-69);}.cls-24{stroke:url(#New_Gradient_Swatch_2-66);}.cls-25{stroke:url(#New_Gradient_Swatch_2-67);}.cls-26{stroke:url(#New_Gradient_Swatch_2-68);}.cls-27{stroke:url(#New_Gradient_Swatch_2-44);}.cls-28{stroke:url(#New_Gradient_Swatch_2-53);}.cls-29{stroke:url(#New_Gradient_Swatch_2-57);}.cls-30{stroke:url(#New_Gradient_Swatch_2-56);}.cls-31{stroke:url(#New_Gradient_Swatch_2-47);}.cls-32{stroke:url(#New_Gradient_Swatch_2-48);}.cls-33{stroke:url(#New_Gradient_Swatch_2-49);}.cls-34{stroke:url(#New_Gradient_Swatch_2-46);}.cls-35{stroke:url(#New_Gradient_Swatch_2-40);}.cls-36{stroke:url(#New_Gradient_Swatch_2-41);}.cls-37{stroke:url(#New_Gradient_Swatch_2-62);}.cls-38{stroke:url(#New_Gradient_Swatch_2-36);}.cls-39{stroke:url(#New_Gradient_Swatch_2-16);}.cls-40{stroke:url(#New_Gradient_Swatch_2-39);}.cls-41{stroke:url(#New_Gradient_Swatch_2-38);}.cls-42{stroke:url(#New_Gradient_Swatch_2-37);}.cls-43{stroke:url(#New_Gradient_Swatch_2-63);}.cls-44{stroke:url(#New_Gradient_Swatch_2-65);}.cls-45{stroke:url(#New_Gradient_Swatch_2-64);}.cls-46{stroke:url(#New_Gradient_Swatch_2-51);}.cls-47{stroke:url(#New_Gradient_Swatch_2-52);}.cls-48{stroke:url(#New_Gradient_Swatch_2-55);}.cls-49{stroke:url(#New_Gradient_Swatch_2-61);}.cls-50{stroke:url(#New_Gradient_Swatch_2-60);}.cls-51{stroke:url(#New_Gradient_Swatch_2-54);}.cls-52{stroke:url(#New_Gradient_Swatch_2-81);}.cls-53{stroke:url(#New_Gradient_Swatch_2-94);}.cls-54{stroke:url(#New_Gradient_Swatch_2-93);}.cls-55{stroke:url(#New_Gradient_Swatch_2-92);}.cls-56{stroke:url(#New_Gradient_Swatch_2-96);}.cls-57{stroke:url(#New_Gradient_Swatch_2-90);}.cls-58{stroke:url(#New_Gradient_Swatch_2-95);}.cls-59{stroke:url(#New_Gradient_Swatch_2-91);}.cls-60{stroke:url(#New_Gradient_Swatch_2-83);}.cls-61{stroke:url(#New_Gradient_Swatch_2-27);}.cls-62{stroke:url(#New_Gradient_Swatch_2-23);}.cls-63{stroke:url(#New_Gradient_Swatch_2-29);}.cls-64{stroke:url(#New_Gradient_Swatch_2-20);}.cls-65{stroke:url(#New_Gradient_Swatch_2-24);}.cls-66{stroke:url(#New_Gradient_Swatch_2-26);}.cls-67{stroke:url(#New_Gradient_Swatch_2-25);}.cls-68{stroke:url(#New_Gradient_Swatch_2-21);}.cls-69{stroke:url(#New_Gradient_Swatch_2-22);}.cls-70{stroke:url(#New_Gradient_Swatch_2-28);}.cls-71{stroke:url(#New_Gradient_Swatch_2-82);}.cls-72{stroke:url(#New_Gradient_Swatch_2-84);}.cls-73{stroke:url(#New_Gradient_Swatch_2-89);}.cls-74{stroke:url(#New_Gradient_Swatch_2-87);}.cls-75{stroke:url(#New_Gradient_Swatch_2-88);}.cls-76{stroke:url(#New_Gradient_Swatch_2-85);}.cls-77{stroke:url(#New_Gradient_Swatch_2-80);}.cls-78{stroke:url(#New_Gradient_Swatch_2-86);}.cls-79{stroke:url(#New_Gradient_Swatch_2-70);}.cls-80{stroke:url(#New_Gradient_Swatch_2-76);}.cls-81{stroke:url(#New_Gradient_Swatch_2-73);}.cls-82{stroke:url(#New_Gradient_Swatch_2-78);}.cls-83{stroke:url(#New_Gradient_Swatch_2-75);}.cls-84{stroke:url(#New_Gradient_Swatch_2-72);}.cls-85{stroke:url(#New_Gradient_Swatch_2-77);}.cls-86{stroke:url(#New_Gradient_Swatch_2-74);}.cls-87{stroke:url(#New_Gradient_Swatch_2-71);}.cls-98{fill:#2e3190;}.cls-88{stroke:url(#New_Gradient_Swatch_2-8);}.cls-89{stroke:url(#New_Gradient_Swatch_2-7);}.cls-90{stroke:url(#New_Gradient_Swatch_2-9);}.cls-91{stroke:url(#New_Gradient_Swatch_2-6);}.cls-92{stroke:url(#New_Gradient_Swatch_2-5);}.cls-93{stroke:url(#New_Gradient_Swatch_2-4);}.cls-99{fill:url(#New_Gradient_Swatch_2);}.cls-94{stroke:url(#New_Gradient_Swatch_2-97);}.cls-94,.cls-95,.cls-96,.cls-97{stroke-width:1.24px;}.cls-95{stroke:url(#New_Gradient_Swatch_2-98);}.cls-96{stroke:url(#New_Gradient_Swatch_2-99);}.cls-97{stroke:url(#New_Gradient_Swatch_2-50);}.cls-100{fill:url(#linear-gradient-2);}.cls-101{fill:url(#New_Gradient_Swatch_2-2);}.cls-102{fill:url(#New_Gradient_Swatch_2-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    x1: 23.16,
    y1: 77.54,
    x2: 23.16,
    y2: 76.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0a5cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-2",
    x1: 23.51,
    y1: 76.85,
    x2: 23.51,
    y2: 76.85,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-3",
    x1: 22.77,
    y1: 77.63,
    x2: 22.77,
    y2: 77.54,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-4",
    x1: 107.12,
    y1: 88.67,
    x2: 114.02,
    y2: 88.67,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-5",
    x1: 107.12,
    y1: 76.16,
    x2: 110.77,
    y2: 76.16,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-6",
    x1: 107.86,
    y1: 55.29,
    x2: 114.05,
    y2: 55.29,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-7",
    x1: 100.87,
    y1: 49.05,
    x2: 106.74,
    y2: 49.05,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-8",
    x1: 90.29,
    y1: 53.41,
    x2: 97.75,
    y2: 53.41,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-9",
    x1: 81.66,
    y1: 57.96,
    x2: 87.29,
    y2: 57.96,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-10",
    x1: 80.25,
    y1: 75.02,
    x2: 81.64,
    y2: 75.02,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-11",
    x1: 81.86,
    y1: 93.45,
    x2: 90.5,
    y2: 93.45,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-12",
    x1: 91.24,
    y1: 92.1,
    x2: 95.09,
    y2: 92.1,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-13",
    x1: 81.69,
    y1: 80.56,
    x2: 87.56,
    y2: 80.56,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-14",
    x1: 89.23,
    y1: 79.2,
    x2: 93.99,
    y2: 79.2,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-15",
    x1: 83.24,
    y1: 85,
    x2: 92.62,
    y2: 85,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-16",
    x1: 92.38,
    y1: 95.81,
    x2: 97.75,
    y2: 95.81,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-17",
    x1: 99.47,
    y1: 94.17,
    x2: 105.96,
    y2: 94.17,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-18",
    x1: 93.66,
    y1: 98.58,
    x2: 105.62,
    y2: 98.58,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-19",
    x1: 95.24,
    y1: 87.97,
    x2: 98.23,
    y2: 87.97,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-20",
    x1: 95.31,
    y1: 77.25,
    x2: 100.35,
    y2: 77.25,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-21",
    x1: 101.25,
    y1: 76.01,
    x2: 105.99,
    y2: 76.01,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-22",
    x1: 99.03,
    y1: 86.06,
    x2: 105.86,
    y2: 86.06,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-23",
    x1: 93.67,
    y1: 68.48,
    x2: 98.89,
    y2: 68.48,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-24",
    x1: 92.81,
    y1: 60.83,
    x2: 99.29,
    y2: 60.83,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-25",
    x1: 101.03,
    y1: 58.56,
    x2: 106.51,
    y2: 58.56,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-26",
    x1: 100.78,
    y1: 62.87,
    x2: 103.23,
    y2: 62.87,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-27",
    x1: 90.01,
    y1: 48.06,
    x2: 106.32,
    y2: 48.06,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-28",
    x1: 88.08,
    y1: 59.69,
    x2: 92.58,
    y2: 59.69,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-29",
    x1: 83.19,
    y1: 65.15,
    x2: 90.91,
    y2: 65.15,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-30",
    x1: 81.74,
    y1: 69.22,
    x2: 87.51,
    y2: 69.22,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-31",
    x1: 90.46,
    y1: 72.8,
    x2: 98.6,
    y2: 72.8,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-32",
    x1: 93.41,
    y1: 103.56,
    x2: 103.61,
    y2: 103.56,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-33",
    x1: 104.93,
    y1: 101.36,
    x2: 107.49,
    y2: 101.36,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-34",
    x1: 77.78,
    y1: 86.36,
    x2: 84.12,
    y2: 86.36,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-35",
    x1: 105.36,
    y1: 44.84,
    x2: 111.7,
    y2: 44.84,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-36",
    x1: 88.25,
    y1: 100.55,
    x2: 94.59,
    y2: 100.55,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-37",
    x1: 85.13,
    y1: 74.76,
    x2: 91.47,
    y2: 74.76,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-38",
    x1: 84.83,
    y1: 52.24,
    x2: 91.17,
    y2: 52.24,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-39",
    x1: 96.88,
    y1: 54.59,
    x2: 103.22,
    y2: 54.59,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-40",
    x1: 77.78,
    y1: 63.68,
    x2: 84.12,
    y2: 63.68,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-41",
    x1: 91.74,
    y1: 83.65,
    x2: 98.09,
    y2: 83.65,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-42",
    x1: 95.81,
    y1: 91.64,
    x2: 100.75,
    y2: 91.64,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-43",
    x1: 104,
    y1: 80.35,
    x2: 108.89,
    y2: 80.35,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-44",
    x1: 97.58,
    y1: 70.84,
    x2: 103.92,
    y2: 70.84,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-45",
    x1: 104.69,
    y1: 61.88,
    x2: 109.59,
    y2: 61.88,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-46",
    x1: 90,
    y1: 66.45,
    x2: 94.89,
    y2: 66.45,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-47",
    x1: 104.69,
    y1: 96.7,
    x2: 109.59,
    y2: 96.7,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-48",
    x1: 113.69,
    y1: 90.28,
    x2: 115.09,
    y2: 90.28,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-49",
    x1: 111.02,
    y1: 77.6,
    x2: 115.06,
    y2: 77.6,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-50",
    x1: 109.18,
    y1: 51.98,
    x2: 120.46,
    y2: 51.98,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-51",
    x1: 117.64,
    y1: 49.94,
    x2: 120.74,
    y2: 49.94,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-52",
    x1: 123.77,
    y1: 53.41,
    x2: 131.24,
    y2: 53.41,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-53",
    x1: 134.24,
    y1: 57.96,
    x2: 139.87,
    y2: 57.96,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-54",
    x1: 139.88,
    y1: 75.02,
    x2: 141.28,
    y2: 75.02,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-55",
    x1: 131.02,
    y1: 93.45,
    x2: 139.67,
    y2: 93.45,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-56",
    x1: 126.43,
    y1: 92.1,
    x2: 130.29,
    y2: 92.1,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-57",
    x1: 133.97,
    y1: 80.56,
    x2: 139.84,
    y2: 80.56,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-58",
    x1: 127.54,
    y1: 79.2,
    x2: 132.3,
    y2: 79.2,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-59",
    x1: 128.91,
    y1: 85,
    x2: 138.29,
    y2: 85,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-60",
    x1: 123.78,
    y1: 95.81,
    x2: 129.14,
    y2: 95.81,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-61",
    x1: 115.56,
    y1: 94.17,
    x2: 122.05,
    y2: 94.17,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-62",
    x1: 115.91,
    y1: 98.58,
    x2: 127.87,
    y2: 98.58,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-63",
    x1: 123.3,
    y1: 87.97,
    x2: 126.29,
    y2: 87.97,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-64",
    x1: 121.17,
    y1: 77.25,
    x2: 126.21,
    y2: 77.25,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-65",
    x1: 114.54,
    y1: 77.68,
    x2: 120.3,
    y2: 77.68,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-66",
    x1: 115.25,
    y1: 87.74,
    x2: 122.37,
    y2: 87.74,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-67",
    x1: 122.64,
    y1: 68.48,
    x2: 127.86,
    y2: 68.48,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-68",
    x1: 122.24,
    y1: 60.83,
    x2: 128.72,
    y2: 60.83,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-69",
    x1: 114.83,
    y1: 59.94,
    x2: 120.62,
    y2: 59.94,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-70",
    x1: 115.17,
    y1: 67.51,
    x2: 119.47,
    y2: 67.51,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-71",
    x1: 119,
    y1: 49.05,
    x2: 131.49,
    y2: 49.05,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-72",
    x1: 128.95,
    y1: 59.69,
    x2: 133.45,
    y2: 59.69,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-73",
    x1: 130.62,
    y1: 65.15,
    x2: 138.34,
    y2: 65.15,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-74",
    x1: 134.02,
    y1: 69.22,
    x2: 139.78,
    y2: 69.22,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-75",
    x1: 122.93,
    y1: 72.8,
    x2: 131.07,
    y2: 72.8,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-76",
    x1: 116.36,
    y1: 104.09,
    x2: 128.14,
    y2: 104.09,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-77",
    x1: 107.72,
    y1: 101.59,
    x2: 114.91,
    y2: 101.59,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-78",
    x1: 137.41,
    y1: 86.36,
    x2: 143.75,
    y2: 86.36,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-79",
    x1: 115.78,
    y1: 46.2,
    x2: 119.67,
    y2: 46.2,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-80",
    x1: 126.94,
    y1: 100.55,
    x2: 133.28,
    y2: 100.55,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-81",
    x1: 130.05,
    y1: 74.76,
    x2: 136.39,
    y2: 74.76,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-82",
    x1: 130.36,
    y1: 52.24,
    x2: 136.7,
    y2: 52.24,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-83",
    x1: 118.31,
    y1: 54.59,
    x2: 124.65,
    y2: 54.59,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-84",
    x1: 137.41,
    y1: 63.68,
    x2: 143.75,
    y2: 63.68,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-85",
    x1: 123.44,
    y1: 83.65,
    x2: 129.78,
    y2: 83.65,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-86",
    x1: 120.78,
    y1: 91.64,
    x2: 125.72,
    y2: 91.64,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-87",
    x1: 111.94,
    y1: 83.86,
    x2: 116.83,
    y2: 83.86,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-88",
    x1: 117.61,
    y1: 70.84,
    x2: 123.95,
    y2: 70.84,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-89",
    x1: 111.94,
    y1: 64.68,
    x2: 116.83,
    y2: 64.68,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-90",
    x1: 126.64,
    y1: 66.45,
    x2: 131.53,
    y2: 66.45,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-91",
    x1: 111.22,
    y1: 107.63,
    x2: 117.56,
    y2: 107.63,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-92",
    x1: 111.94,
    y1: 96.7,
    x2: 116.83,
    y2: 96.7,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-93",
    x1: 102.61,
    y1: 105.91,
    x2: 107.5,
    y2: 105.91,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-94",
    x1: 108.55,
    y1: 71.59,
    x2: 113.45,
    y2: 71.59,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-95",
    x1: 102.09,
    y1: 66.56,
    x2: 107.05,
    y2: 66.56,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-96",
    x1: 102.41,
    y1: 67.58,
    x2: 113.04,
    y2: 67.58,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-97",
    x1: 106.32,
    y1: 107.12,
    x2: 112.03,
    y2: 107.12,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-98",
    x1: 108.55,
    y1: 96.27,
    x2: 112.3,
    y2: 96.27,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2-99",
    x1: 111.01,
    y1: 45.08,
    x2: 116.46,
    y2: 45.08,
    xlinkHref: "#New_Gradient_Swatch_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 107.15,
    y1: 130.24,
    x2: 107.15,
    y2: 21.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2d3394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#0a5cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 24.99,
    y1: 75.42,
    x2: 24.99,
    y2: 75.33,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M176.43,139.76h-19.74v6.21h22.95c1.77,0,3.21-1.39,3.21-3.1v-21.56h-6.41v18.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M179.63,6.81h-22.95v6.21h19.74V31.47h6.41V9.91c0-1.71-1.44-3.1-3.21-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M37.33,9.91V31.47h6.41V13.01h19.74V6.81h-22.95c-1.77,0-3.2,1.39-3.2,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M43.74,121.31h-6.41v21.56c0,1.71,1.44,3.1,3.2,3.1h22.95v-6.21h-19.74v-18.45Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M23.51,76.85c-.31,.31-.56,.56-.7,.69,.1-.1,.33-.33,.7-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M23.51,76.85h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M22.82,77.54c-.11,.11-.1,.1,0,0h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-93",
    x1: 107.77,
    y1: 82.09,
    x2: 113.38,
    y2: 95.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-92",
    x1: 110.12,
    y1: 73.11,
    x2: 107.77,
    y2: 79.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-91",
    x1: 108.53,
    y1: 47.34,
    x2: 113.38,
    y2: 63.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-89",
    x1: 101.45,
    y1: 52.53,
    x2: 106.16,
    y2: 45.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-88",
    x1: 90.42,
    y1: 52.71,
    x2: 97.62,
    y2: 54.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 82.25,
    y1: 61.56,
    x2: 86.69,
    y2: 54.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.95,
    y1: 83.86,
    x2: 80.95,
    y2: 66.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 89.94,
    y1: 98.55,
    x2: 82.42,
    y2: 88.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 91.92,
    y1: 98.1,
    x2: 94.41,
    y2: 86.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 86.97,
    y1: 76.86,
    x2: 82.28,
    y2: 84.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 93.43,
    y1: 81.65,
    x2: 89.79,
    y2: 76.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 83.37,
    y1: 85.89,
    x2: 92.49,
    y2: 84.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 97.19,
    y1: 93.05,
    x2: 92.94,
    y2: 98.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 105.62,
    y1: 95.83,
    x2: 99.82,
    y2: 92.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 93.82,
    y1: 99.97,
    x2: 105.46,
    y2: 97.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 95.88,
    y1: 85.95,
    x2: 97.59,
    y2: 89.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-64",
    x1: 99.72,
    y1: 73.11,
    x2: 95.95,
    y2: 81.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 105.39,
    y1: 78.94,
    x2: 101.85,
    y2: 73.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 99.61,
    y1: 90.46,
    x2: 105.28,
    y2: 81.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-62",
    x1: 93.99,
    y1: 67.27,
    x2: 98.56,
    y2: 69.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-65",
    x1: 98.7,
    y1: 56.69,
    x2: 93.39,
    y2: 64.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-67",
    x1: 106.06,
    y1: 60.5,
    x2: 101.48,
    y2: 56.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-66",
    x1: 102.54,
    y1: 69.12,
    x2: 101.48,
    y2: 56.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-61",
    x1: 90.28,
    y1: 51.27,
    x2: 106.06,
    y2: 44.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: 91.92,
    y1: 64.77,
    x2: 88.74,
    y2: 54.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-63",
    x1: 83.35,
    y1: 64.26,
    x2: 90.74,
    y2: 66.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 86.92,
    y1: 72.68,
    x2: 82.32,
    y2: 65.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 98.39,
    y1: 71.59,
    x2: 90.66,
    y2: 74.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 103.35,
    y1: 105.55,
    x2: 93.68,
    y2: 101.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 106.8,
    y1: 98.47,
    x2: 105.62,
    y2: 104.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 80.95,
    cy: 86.36,
    rx: 2.47,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M111,44.84c0-1.38-1.11-2.5-2.47-2.5s-2.47,1.12-2.47,2.5,1.11,2.5,2.47,2.5,2.47-1.12,2.47-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M93.89,100.55c0-1.38-1.11-2.5-2.47-2.5s-2.47,1.12-2.47,2.5,1.11,2.5,2.47,2.5,2.47-1.12,2.47-2.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-42",
    cx: 88.3,
    cy: 74.76,
    rx: 2.47,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M90.47,52.24c0-1.38-1.11-2.5-2.47-2.5s-2.47,1.12-2.47,2.5,1.11,2.5,2.47,2.5,2.47-1.12,2.47-2.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 100.05,
    cy: 54.59,
    rx: 2.47,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M83.42,63.68c0-1.38-1.11-2.5-2.47-2.5s-2.47,1.12-2.47,2.5,1.11,2.5,2.47,2.5,2.47-1.12,2.47-2.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 94.92,
    cy: 83.65,
    rx: 2.47,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M100.05,91.64c0-.99-.79-1.79-1.77-1.79s-1.77,.8-1.77,1.79,.79,1.79,1.77,1.79,1.77-.8,1.77-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M108.19,80.35c0-.98-.78-1.77-1.75-1.77s-1.75,.79-1.75,1.77,.78,1.77,1.75,1.77,1.75-.79,1.75-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M103.22,70.84c0-1.38-1.11-2.5-2.47-2.5s-2.47,1.12-2.47,2.5,1.11,2.5,2.47,2.5,2.47-1.12,2.47-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M108.89,61.88c0-.98-.78-1.77-1.75-1.77s-1.75,.79-1.75,1.77,.78,1.77,1.75,1.77,1.75-.79,1.75-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M94.19,66.45c0-.98-.78-1.77-1.75-1.77s-1.75,.79-1.75,1.77,.78,1.77,1.75,1.77,1.75-.79,1.75-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M108.89,96.7c0-.98-.78-1.77-1.75-1.77s-1.75,.79-1.75,1.77,.78,1.77,1.75,1.77,1.75-.79,1.75-1.77Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 114.39,
    y1: 85.62,
    x2: 114.39,
    y2: 94.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 111.68,
    y1: 73.11,
    x2: 114.39,
    y2: 82.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-97",
    x1: 109.59,
    y1: 47.34,
    x2: 120.05,
    y2: 56.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-46",
    x1: 120.08,
    y1: 52.53,
    x2: 118.3,
    y2: 47.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-47",
    x1: 131.1,
    y1: 52.71,
    x2: 123.91,
    y2: 54.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 139.27,
    y1: 61.56,
    x2: 134.84,
    y2: 54.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-51",
    x1: 140.58,
    y1: 83.86,
    x2: 140.58,
    y2: 66.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-48",
    x1: 131.58,
    y1: 98.55,
    x2: 139.1,
    y2: 88.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 129.6,
    y1: 98.1,
    x2: 127.12,
    y2: 86.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 134.56,
    y1: 76.86,
    x2: 139.25,
    y2: 84.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 128.1,
    y1: 81.65,
    x2: 131.74,
    y2: 76.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 138.15,
    y1: 85.89,
    x2: 129.04,
    y2: 84.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-50",
    x1: 124.33,
    y1: 93.05,
    x2: 128.59,
    y2: 98.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-49",
    x1: 115.91,
    y1: 95.83,
    x2: 121.71,
    y2: 92.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 127.7,
    y1: 99.97,
    x2: 116.07,
    y2: 97.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 125.64,
    y1: 85.95,
    x2: 123.94,
    y2: 89.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: 121.81,
    y1: 73.11,
    x2: 125.58,
    y2: 81.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 115.16,
    y1: 82.27,
    x2: 119.68,
    y2: 73.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 121.91,
    y1: 90.46,
    x2: 115.71,
    y2: 85.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 127.54,
    y1: 67.27,
    x2: 122.97,
    y2: 69.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 122.82,
    y1: 56.69,
    x2: 128.13,
    y2: 64.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 115.4,
    y1: 63.24,
    x2: 120.05,
    y2: 56.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-79",
    x1: 118.99,
    y1: 69.12,
    x2: 115.65,
    y2: 65.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-87",
    x1: 131.25,
    y1: 51.27,
    x2: 119.24,
    y2: 46.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-84",
    x1: 129.61,
    y1: 64.77,
    x2: 132.78,
    y2: 54.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-81",
    x1: 138.18,
    y1: 64.26,
    x2: 130.78,
    y2: 66.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-86",
    x1: 134.6,
    y1: 72.68,
    x2: 139.2,
    y2: 65.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-83",
    x1: 123.14,
    y1: 71.59,
    x2: 130.86,
    y2: 74.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-80",
    x1: 116.64,
    y1: 106.62,
    x2: 127.85,
    y2: 101.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-85",
    x1: 108.25,
    y1: 98.05,
    x2: 114.39,
    y2: 105.13
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-82",
    cx: 140.58,
    cy: 86.36,
    rx: 2.47,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.2,46.2c0-.85,.68-1.54,1.52-1.54s1.52,.69,1.52,1.54-.68,1.54-1.52,1.54-1.52-.69-1.52-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M127.64,100.55c0-1.38,1.11-2.5,2.47-2.5s2.47,1.12,2.47,2.5-1.11,2.5-2.47,2.5-2.47-1.12-2.47-2.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-52",
    cx: 133.22,
    cy: 74.76,
    rx: 2.47,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M131.06,52.24c0-1.38,1.11-2.5,2.47-2.5s2.47,1.12,2.47,2.5-1.11,2.5-2.47,2.5-2.47-1.12-2.47-2.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-60",
    cx: 121.48,
    cy: 54.59,
    rx: 2.47,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M138.11,63.68c0-1.38,1.11-2.5,2.47-2.5s2.47,1.12,2.47,2.5-1.11,2.5-2.47,2.5-2.47-1.12-2.47-2.5Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-76",
    cx: 126.61,
    cy: 83.65,
    rx: 2.47,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M121.48,91.64c0-.99,.79-1.79,1.77-1.79s1.77,.8,1.77,1.79-.79,1.79-1.77,1.79-1.77-.8-1.77-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M112.64,83.86c0-.98,.78-1.77,1.75-1.77s1.75,.79,1.75,1.77-.78,1.77-1.75,1.77-1.75-.79-1.75-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M118.3,70.84c0-1.38,1.11-2.5,2.47-2.5s2.47,1.12,2.47,2.5-1.11,2.5-2.47,2.5-2.47-1.12-2.47-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M112.64,64.68c0-.98,.78-1.77,1.75-1.77s1.75,.79,1.75,1.77-.78,1.77-1.75,1.77-1.75-.79-1.75-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M127.34,66.45c0-.98,.78-1.77,1.75-1.77s1.75,.79,1.75,1.77-.78,1.77-1.75,1.77-1.75-.79-1.75-1.77Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-59",
    cx: 114.39,
    cy: 107.63,
    rx: 2.47,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M112.64,96.7c0-.98,.78-1.77,1.75-1.77s1.75,.79,1.75,1.77-.78,1.77-1.75,1.77-1.75-.79-1.75-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M103.31,105.91c0-.98,.78-1.77,1.75-1.77s1.75,.79,1.75,1.77-.78,1.77-1.75,1.77-1.75-.79-1.75-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M112.75,71.59c0-.98-.78-1.77-1.75-1.77s-1.75,.79-1.75,1.77,.78,1.77,1.75,1.77,1.75-.79,1.75-1.77Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: 102.7,
    y1: 69.87,
    x2: 106.44,
    y2: 63.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-56",
    x1: 112.75,
    y1: 65.29,
    x2: 102.7,
    y2: 69.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-94",
    x1: 106.43,
    y1: 106.62,
    x2: 111.91,
    y2: 107.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-95",
    x1: 108.58,
    y1: 96.19,
    x2: 112.27,
    y2: 96.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96",
    x1: 111.12,
    y1: 44.58,
    x2: 116.34,
    y2: 45.58
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.24,81.94l8.3,3.79c-11.19,10.23-29.12,23.97-50.93,31.21,11.88-9.4,19.52-23.93,19.52-40.22,0-26.61-20.37-48.54-46.33-51.05-1.1-2.6-3.67-4.42-6.66-4.42-2.61,0-4.87,1.39-6.14,3.46-35.45,2.63-64.77,22.15-81.01,35.54-4.01-2.47-9.33-2.01-12.81,1.46-4.07,4.05-4.08,10.66-.03,14.73,4.05,4.07,10.66,4.08,14.73,.03-.13,.13-.25,.25-.37,.37,.12-.12,.22-.22,.37-.37,.6-.59,.91-.9,1.06-1.05-.19,.19-.62,.61-1.06,1.05,3.15-3.13,3.84-7.78,2.13-11.62,12.08-9.95,31.58-23.34,55.36-30.08-13.18,9.29-21.82,24.62-21.82,41.94,0,1.39,.08,2.79,.19,4.18l-9.35-.72c5.91,3.91,12.44,11.04,16.78,17.05,.63-7.38,2.58-16.86,5.64-23.24l-7.07,5.01c-.04-.76-.07-1.52-.07-2.27,0-22.23,16.15-40.75,37.32-44.48,1.27,2.08,3.54,3.47,6.15,3.47,2.8,0,5.19-1.6,6.4-3.93,22.71,2.36,40.48,21.61,40.48,44.93,0,17.04-9.49,31.9-23.45,39.59-1.38-1.16-3.13-1.89-5.07-1.89-3.91,0-7.14,2.85-7.77,6.59-2.51,.5-5.1,.79-7.74,.85-.3,0-.6,0-.91,0-35.17-.94-64.84-19.02-83.53-34.03-1.32-1.05-3.24-.84-4.3,.47s-.85,3.24,.47,4.3c19.41,15.58,50.28,34.36,87.13,35.36v.04c.33,0,.65-.02,.98-.02,.5,0,.99,.02,1.49,.02,2.82,0,5.59-.15,8.33-.4,1.45,1.6,3.52,2.63,5.85,2.63,3.24,0,6.01-1.95,7.23-4.73,27.45-6.32,49.95-23.35,63.18-35.49l3.95,8.2c.41-7.07,3.3-16.31,6.32-23.07-6.7,3.16-15.87,6.24-22.93,6.79Zm-168.66-6.19c-3.65,0-6.61-2.96-6.61-6.61s2.96-6.61,6.61-6.61,6.61,2.96,6.61,6.61-2.96,6.61-6.61,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M24.94,75.42c.12-.12,.14-.14,0,0h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.11960d5df36f9478f35cc456f45cca27.svg";
export { ForwardRef as ReactComponent };